import React from 'react';
import ProductHubDashboardV2 from '../ProductHubDashboard/ProductHubDashboardV2';

const VtnaHubView = () => {
  return <ProductHubDashboardV2 productCode="vnta" productLabel="Ventana" />;
};

export default VtnaHubView;
